export const ServiciosOptionList = [
    { key: "Servicio-2", value: "Cafeteria", label: "Cafeteria" },
    { key: "Servicio-3", value: "Baños", label: "Baños" },
    { key: "Servicio-4", value: "Quincho", label: "Quincho" },
    { key: "Servicio-5", value: "Piscina", label: "Piscina" },
  ];